import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsights = null;

const PII_PATH_SEGMENTS = [
  'participants',
  'studies',
  'sites',
  'sponsors',
  'users',
  'assignments',
  'completed-surveys',
  'responses',
];

const UUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const NUMERIC_ID_PATTERN = /\/\d+(?=\/|$)/g;
const EMAIL_PATTERN = /[\w.+-]+@[\w-]+\.[\w.-]+/g;

export function redactUrl(url) {
  if (!url || typeof url !== 'string') return url;
  let redacted = url;
  for (const segment of PII_PATH_SEGMENTS) {
    redacted = redacted.replace(new RegExp(`/${segment}/[^/?#]+`, 'g'), `/${segment}/:id`);
  }
  redacted = redacted.replace(UUID_PATTERN, ':uuid');
  redacted = redacted.replace(NUMERIC_ID_PATTERN, '/:id');
  redacted = redacted.replace(EMAIL_PATTERN, ':email');
  return redacted;
}

export function initAppInsights() {
  if (appInsights) return appInsights;

  const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING;
  if (!connectionString) return null;

  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
      enableUnhandledPromiseRejectionTracking: true,
      disableFetchTracking: false,
      disableAjaxTracking: false,
      enableCorsCorrelation: true,
      autoTrackPageVisitTime: true,
    },
  });

  appInsights.loadAppInsights();

  appInsights.addTelemetryInitializer((envelope) => {
    const data = envelope.data || {};

    if (data.uri) data.uri = redactUrl(data.uri);
    if (data.target) data.target = redactUrl(data.target);
    if (data.refUri) data.refUri = redactUrl(data.refUri);
    if (data.name && typeof data.name === 'string' && data.name.includes('/')) {
      data.name = redactUrl(data.name);
    }

    if (envelope.tags) {
      delete envelope.tags['ai.user.authUserId'];
      delete envelope.tags['ai.user.accountId'];
    }
  });

  appInsights.trackPageView();
  return appInsights;
}

export function getAppInsights() {
  return appInsights;
}
